/**
 * Handles the display of errors when a pending promise resolves
 * @module lib/withErrorRender
 */

const CLASS_ERROR = 'js-field-error';
const SELECTOR = `.${CLASS_ERROR}`;

const ERROR_POSTCODE_NOT_SWITCHABLE_MESSAGE = `
  We're unable to find any residential properties with the postcode you provided.
  If you live in a new property, we can add your address to our database
  to enable you to get a quote and switch.
  Please email your full address to <a href="mailto:help@bigcleanswitch.org">help@bigcleanswitch.org</a>
  or contact us via live chat.
`;

function removeError(el) {
  const error = el.querySelector(SELECTOR);
  if (error) {
    error.parentNode.removeChild(error);
  }
}

function showError(el, { message, beforeSelector }) {
  const error = `<div class="form-errors mb-3 ${CLASS_ERROR}">${message}</div>`;
  el.querySelector(beforeSelector).insertAdjacentHTML('beforebegin', error);
}

/**
 * Renders an error when the given promise is rejected
 * @param {Promise} promise
 * @param {Object} options
 * @param {HTMLElement} options.scope - The element into which rendering the error
 * @param {string} options.message - The error message
 * @param {string} options.beforeSelector - The selector before which to inject the error
 */
export default function withErrorRender(
  promise,
  { scope, message, beforeSelector } = {}
) {
  return promise
    .then(v => {
      removeError(scope);
      return v;
    })
    .catch(e => {
      removeError(scope);
      if (e.message == 'postcode_not_switchable') {
        showError(scope, {
          message: ERROR_POSTCODE_NOT_SWITCHABLE_MESSAGE,
          beforeSelector
        });
      } else {
        showError(scope, { message, beforeSelector });
      }
    });
}



// WEBPACK FOOTER //
// ./app/webpack/javascripts/lib/withErrorRender.js